import {
  View,
  Text,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  Alert,
} from "react-native";
import React, { useEffect, useState } from "react";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useStateContext } from "../lib/context";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import Header from "../components/Header";
import Toast from "react-native-toast-message";

const Order = ({ navigation, route }) => {
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [estado, setEstado] = useState(route.params.estado || "Procesando");
  const [eroResult, setEroResult] = useState("");
  const [drnResult, setDrnResult] = useState("");

  const { admin } = useStateContext();
  const {
    matrix: promoMatrix = [], // Default to empty array if undefined
    promoDrn: promoIdDrn,
    promoEro: promoIdEro,
    items: cartItems = [],
  } = route.params;

  const showToast = () => {
    Toast.show({
      type: "success",
      text1: "Pedido Reenviado con Éxito",
    });
  };

  useEffect(() => {
    if (eroResult != "") updateEro();
  }, [eroResult]);

  useEffect(() => {
    if (drnResult != "") updateDrn();
  }, [drnResult]);

  const updateEro = () => {
    const unique = route.params.user + route.params.fecha;
    updateDoc(doc(db, "orders", unique), { ero: eroResult })
      .then(() => {
        console.log("Ero updated");
        showToast();
        navigation.navigate("Home");
      })
      .catch((error) => console.error("Error updating Ero:", error));
  };

  const updateDrn = () => {
    const unique = route.params.user + route.params.fecha;
    updateDoc(doc(db, "orders", unique), { drn: drnResult })
      .then(() => {
        console.log("Drn updated");
        showToast();
        navigation.navigate("Home");
      })
      .catch((error) => console.error("Error updating Drn:", error));
  };

  const eroReTry = async () => {
    if (!route.params.eroUrl) return;
    try {
      const urlObj = new URL(route.params.eroUrl);
      const documentContent = urlObj.searchParams.get("documento");

      fetch("https://erodistribuciones.com/proxyv2.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          baseUrl: "http://sa08.ddns.net:7780/AppRest/servlet/ServletAndroid",
          params: {
            empresa: "ero",
            usuario: "consultaweb",
            clave: "web3007",
            dato: "enviodocumento",
          },
          xml: documentContent,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setEroResult(data.response);
          console.log("Response from proxy:", data);
        })
        .catch((err) => console.error("Proxy error:", err));
    } catch (e) {
      console.error("Error parsing URL or fetching", e);
    }
  };

  const drnReTry = async () => {
    if (!route.params.drnUrl) return;
    try {
      const urlObj = new URL(route.params.drnUrl);
      const documentContent = urlObj.searchParams.get("documento");

      fetch("https://erodistribuciones.com/proxyv2.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          baseUrl: "http://sa08.ddns.net:7780/AppRest/servlet/ServletAndroid",
          params: {
            empresa: "drn",
            usuario: "consultaweb",
            clave: "web3007",
            dato: "enviodocumento",
          },
          xml: documentContent,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setDrnResult(data.response);
          console.log("Response from proxy:", data);
        })
        .catch((err) => console.error("Proxy error:", err));
    } catch (e) {
      console.error("Error parsing URL or fetching", e);
    }
  };

  const updateEstado = (nuevoEstado) => {
    const unique = route.params.user + route.params.fecha;
    updateDoc(doc(db, "orders", unique), { estado: nuevoEstado })
      .then(() => setEstado(nuevoEstado))
      .catch((err) => console.error("Error updating estado:", err));
  };

  // Calculate Totals using logic from Checkout/Cart
  useEffect(() => {
    const newTotal = cartItems.reduce((sum, item) => {
      return sum + Number(item.price) * Number(item.quantity);
    }, 0);
    setTotal(newTotal);

    const newDiscount = cartItems.reduce((sum, item) => {
      // Safe access to matrix using optional chaining
      const chu =
        item.type == "1"
          ? promoMatrix[promoIdEro]?.uno || 0
          : item.type == "2"
            ? promoMatrix[promoIdDrn]?.dos || 0
            : item.type == "3"
              ? promoMatrix[promoIdEro]?.tres || 0
              : promoMatrix[promoIdEro]?.nueve || 0;

      const temp = ((parseInt(chu) * item.price) / 100).toFixed(2);
      return sum + Number(temp) * Number(item.quantity);
    }, 0);
    setDiscount(newDiscount);
  }, [cartItems]);

  const formattedDate = new Date(route.params.fecha).toLocaleDateString(
    "es-AR",
    {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    },
  );

  return (
    <View style={localStyles.container}>
      <Header
        title={`Pedido ${formattedDate}`}
        navigation={navigation}
        isBack={true}
      />

      <ScrollView
        contentContainerStyle={localStyles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {/* Status Badge */}
        <View style={[
          localStyles.statusBadge,
          estado === "Finalizado" ? localStyles.statusFinalizado : localStyles.statusProcesando
        ]}>
          <Ionicons
            name={estado === "Finalizado" ? "checkmark-circle" : "time"}
            size={16}
            color={estado === "Finalizado" ? "#2E7D32" : "#E65100"}
          />
          <Text style={[
            localStyles.statusText,
            estado === "Finalizado" ? localStyles.statusTextFinalizado : localStyles.statusTextProcesando
          ]}>
            {estado}
          </Text>
        </View>

        {/* Info Card */}
        <View style={localStyles.card}>
          <Text style={localStyles.cardTitle}>Información de Envío</Text>
          <View style={localStyles.infoRow}>
            <Ionicons name="bus-outline" size={18} color="#666" />
            <Text style={localStyles.infoText}>
              {route.params.transporte || "No especificado"}
            </Text>
          </View>
          {route.params.transporteInfo !== "" && (
            <View style={localStyles.infoRow}>
              <Ionicons name="person-outline" size={18} color="#666" />
              <Text style={localStyles.infoText}>
                {route.params.transporteInfo}
              </Text>
            </View>
          )}
          {route.params.transporTel !== "" && (
            <View style={localStyles.infoRow}>
              <Ionicons name="call-outline" size={18} color="#666" />
              <Text style={localStyles.infoText}>
                {route.params.transporTel}
              </Text>
            </View>
          )}
          <View style={localStyles.infoRow}>
            <Ionicons name="card-outline" size={18} color="#666" />
            <Text style={localStyles.infoText}>
              {route.params.pago || "No especificado"}
            </Text>
          </View>

        </View>

        {/* Admin Info */}
        {(admin || route.params.ero || route.params.drn) && (
          <View style={localStyles.card}>
            <Text style={localStyles.cardTitle}>Detalles del Sistema</Text>
            {/* Only show these if they exist */}
            {route.params.ero ? (
              <Text style={localStyles.adminText}>
                ERO ID: {route.params.ero}
              </Text>
            ) : null}
            {route.params.drn ? (
              <Text style={localStyles.adminText}>
                DRN ID: {route.params.drn}
              </Text>
            ) : null}
          </View>
        )}

        {/* Items List */}
        <Text style={localStyles.sectionTitle}>Productos</Text>
        {cartItems.map((item, index) => {
          const chu =
            item.type == "1"
              ? promoMatrix[promoIdEro]?.uno || 0
              : item.type == "2"
                ? promoMatrix[promoIdDrn]?.dos || 0
                : item.type == "3"
                  ? promoMatrix[promoIdEro]?.tres || 0
                  : promoMatrix[promoIdEro]?.nueve || 0;

          const price = Number(item.price);
          const discontinuedPrice = price - (parseInt(chu) * price) / 100;
          const itemTotal = discontinuedPrice * item.quantity;

          return (
            <View key={index} style={localStyles.itemCard}>
              <View style={localStyles.itemHeader}>
                <Text style={localStyles.itemName}>{item.name}</Text>
                <Text style={localStyles.itemSku}>{item.sku}</Text>
              </View>

              <View style={localStyles.itemDetails}>
                <Text style={localStyles.itemQty}>x {item.quantity}</Text>
                <View style={localStyles.priceColumn}>
                  {chu > 0 && (
                    <Text style={localStyles.oldPrice}>
                      ${price.toFixed(2)}
                    </Text>
                  )}
                  <Text style={localStyles.finalPrice}>
                    ${discontinuedPrice.toFixed(2)}
                  </Text>
                </View>
              </View>
              <View style={localStyles.itemFooter}>
                <Text style={localStyles.itemTotalLabel}>
                  Total:{" "}
                  <Text style={localStyles.itemTotalValue}>
                    ${itemTotal.toFixed(2)}
                  </Text>
                </Text>
                {chu > 0 && (
                  <Text style={localStyles.discountTag}>-{chu}% OFF</Text>
                )}
              </View>
            </View>
          );
        })}

        {/* Summary */}
        <View style={localStyles.summaryCard}>
          <View style={localStyles.summaryRow}>
            <Text style={localStyles.summaryLabel}>Subtotal</Text>
            <Text style={localStyles.summaryValue}>${total.toFixed(2)}</Text>
          </View>
          {discount > 0 && (
            <View style={localStyles.summaryRow}>
              <Text style={localStyles.discountLabel}>Descuento</Text>
              <Text style={localStyles.discountValue}>
                -${discount.toFixed(2)}
              </Text>
            </View>
          )}
          <View style={[localStyles.summaryRow, localStyles.totalRow]}>
            <Text style={localStyles.totalLabel}>Total (+IVA)</Text>
            <Text style={localStyles.totalValue}>
              ${(total - discount).toFixed(2)}
            </Text>
          </View>
        </View>

        {/* Actions */}
        <TouchableOpacity
          style={localStyles.actionButton}
          onPress={() => navigation.navigate("Imprimir", route.params)}
        >
          <Ionicons name="print-outline" size={20} color="#fff" />
          <Text style={localStyles.actionButtonText}>Imprimir Pedido</Text>
        </TouchableOpacity>

        {admin && (
          <View style={localStyles.adminActions}>
            <TouchableOpacity
              style={[localStyles.adminButton, { backgroundColor: "#FF9800" }]}
              onPress={eroReTry}
            >
              <Text style={localStyles.adminButtonText}>Reenviar ERO</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[localStyles.adminButton, { backgroundColor: "#2196F3" }]}
              onPress={drnReTry}
            >
              <Text style={localStyles.adminButtonText}>Reenviar DRN</Text>
            </TouchableOpacity>
          </View>
        )}

        {admin && (
          <View style={localStyles.adminActions}>
            <TouchableOpacity
              style={[localStyles.adminButton, { backgroundColor: "#FF9800", opacity: estado === "Procesando" ? 0.4 : 1 }]}
              onPress={() => updateEstado("Procesando")}
              disabled={estado === "Procesando"}
            >
              <Text style={localStyles.adminButtonText}>Procesando</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[localStyles.adminButton, { backgroundColor: "#4CAF50", opacity: estado === "Finalizado" ? 0.4 : 1 }]}
              onPress={() => updateEstado("Finalizado")}
              disabled={estado === "Finalizado"}
            >
              <Text style={localStyles.adminButtonText}>Finalizado</Text>
            </TouchableOpacity>
          </View>
        )}

        <View style={{ height: 40 }} />
      </ScrollView>
    </View>
  );
};

export default Order;

const localStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6FD",
  },
  scrollContent: {
    padding: 20,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#333",
    marginBottom: 12,
    marginTop: 20,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#333",
    marginBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#f0f0f0",
    paddingBottom: 8,
  },
  infoRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    marginBottom: 8,
  },
  infoText: {
    fontSize: 14,
    color: "#555",
  },
  noteContainer: {
    marginTop: 10,
    backgroundColor: "#FFF9C4",
    padding: 10,
    borderRadius: 8,
  },
  noteLabel: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#FBC02D",
    marginBottom: 4,
  },
  noteText: {
    fontSize: 13,
    color: "#333",
  },
  adminText: {
    fontSize: 12,
    fontFamily: "monospace",
    color: "#666",
  },
  itemCard: {
    backgroundColor: "#fff",
    borderRadius: 10,
    padding: 12,
    marginBottom: 10,
    shadowColor: "#000",
    shadowOpacity: 0.03,
    elevation: 1,
  },
  itemHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  itemName: {
    fontSize: 14,
    fontWeight: "600",
    color: "#333",
    flex: 1,
    marginRight: 10,
  },
  itemSku: {
    fontSize: 12,
    color: "#999",
  },
  itemDetails: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  itemQty: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#444",
  },
  priceColumn: {
    alignItems: "flex-end",
  },
  oldPrice: {
    fontSize: 11,
    textDecorationLine: "line-through",
    color: "#999",
  },
  finalPrice: {
    fontSize: 14,
    fontWeight: "600",
    color: "#2a2a8e",
  },
  itemFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderTopWidth: 1,
    borderTopColor: "#f5f5f5",
    paddingTop: 8,
    marginTop: 4,
  },
  itemTotalLabel: {
    fontSize: 13,
    color: "#666",
  },
  itemTotalValue: {
    fontWeight: "bold",
    color: "#333",
  },
  discountTag: {
    fontSize: 10,
    color: "#FF5722",
    fontWeight: "bold",
    backgroundColor: "#FFCCBC",
    paddingHorizontal: 4,
    paddingVertical: 2,
    borderRadius: 4,
  },
  summaryCard: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16,
    marginTop: 10,
    marginBottom: 20,
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  summaryLabel: {
    fontSize: 14,
    color: "#666",
  },
  summaryValue: {
    fontSize: 14,
    fontWeight: "600",
    color: "#333",
  },
  discountLabel: {
    fontSize: 14,
    color: "#4CAF50",
    fontWeight: "500",
  },
  discountValue: {
    fontSize: 14,
    fontWeight: "600",
    color: "#4CAF50",
  },
  totalRow: {
    marginTop: 8,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: "#f0f0f0",
  },
  totalLabel: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#333",
  },
  totalValue: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#2a2a8e",
  },
  actionButton: {
    backgroundColor: "#2a2a8e",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 14,
    borderRadius: 10,
    gap: 8,
    marginBottom: 20,
  },
  actionButtonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600",
  },
  adminActions: {
    flexDirection: "row",
    gap: 10,
    marginTop: 10,
  },
  adminButton: {
    flex: 1,
    padding: 12,
    borderRadius: 8,
    alignItems: "center",
  },
  adminButtonText: {
    color: "#fff",
    fontWeight: "600",
    fontSize: 13,
  },
  statusBadge: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "flex-start",
    gap: 6,
    paddingHorizontal: 14,
    paddingVertical: 7,
    borderRadius: 20,
    marginBottom: 16,
  },
  statusProcesando: {
    backgroundColor: "#FFF3E0",
    borderWidth: 1,
    borderColor: "#FF9800",
  },
  statusFinalizado: {
    backgroundColor: "#E8F5E9",
    borderWidth: 1,
    borderColor: "#4CAF50",
  },
  statusText: {
    fontSize: 13,
    fontWeight: "700",
  },
  statusTextProcesando: {
    color: "#E65100",
  },
  statusTextFinalizado: {
    color: "#2E7D32",
  },
});
